import { BlockCauseRowActions } from 'modules/crm/settings/block-cause/components/BlockCauseRowActions';
import { EditLink, HeadCell } from '@dfl/mui-admin-layout';
import { IBlockCause } from 'modules/crm/settings/block-cause/interfaces';
import { createdATColumn } from 'modules/common/constants/common.columns';
import { BLOCK_CAUSE_PERMISSIONS } from 'modules/crm/settings/block-cause/constants/block-cause.permissions';

export const blockCauseNameColumn: HeadCell<IBlockCause> = {
  field: 'name',
  headerName: 'blockCause:fields.name',
  disablePadding: false,
  renderCell: (name: string, data?: IBlockCause) => (<EditLink entityId={data?._id as string}>{name}</EditLink>),
};

export const blockCauseDescriptionColumn: HeadCell<IBlockCause> = {
  field: 'description',
  headerName: 'blockCause:fields.description',
};

export const blockCauseActionsColumn: HeadCell<IBlockCause> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: BLOCK_CAUSE_PERMISSIONS.BLOCK_CAUSE_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  component: BlockCauseRowActions,
};

export const blockCauseColumns: Array<HeadCell<any>> = [
  blockCauseNameColumn,
  blockCauseDescriptionColumn,
  createdATColumn,
  blockCauseActionsColumn
];
